module.exports = __webpack_public_path__ + "img/Small_kerstin.c3503d92.png";